<template>
    <el-dialog
    title="学习记录"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    @close="close"
    width="120rem">
    <div class="content-box">
        <div style="display: flex;">
            <div class="select-label">
                <p>课程名称：</p>
                <el-select filterable v-model="courseInfo.openCourseId" @change="changeCourse" placeholder="请选择课程">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="select-label" style="margin-left: 2rem;">
                <p>学生名称：</p>
                <el-select v-show="courseInfo.openCourseId" filterable v-model="detail.userId" @change="changeUser" placeholder="请选择学生">
                    <el-option
                    v-for="item in userOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </div>
        <div class="table-content-box">
           <study-table ref="study_table" courseLearningSource="course_task" :openCourseId="courseInfo.openCourseId" :detail="detail" :courseInfo="courseInfo"></study-table>
        </div>
    </div>
    </el-dialog>
</template>

<script>
import StudyTable from '@/components/personCenter/myselfCourse/StudyTable.vue';
import { GetCourseStudyUser } from '@/api/course';
export default {
  components: { StudyTable },
        data(){
            return {
                dialogVisible:false,
                detail:{
                    userId:'',
                    userName:''
                },
                courseInfo:{
                    openCourseId:'',
                    id:''
                },
                courseTaskId:'',
                options:[],
                userOptions:[]
            }
        },
        methods:{
            /**查看记录列表 */
            viewTrainList(){
                this.$nextTick(()=>{
                    let dom=this.$refs.study_table;
                    if(dom){
                        dom.pages.current=1;
                        dom.pageQueryCourseStudyCount();
                    }
                })
            },
            getCourseStudyUser(){
                let params={
                    "courseLearningSource": "course_task",
                    "openCourseId": this.courseInfo.openCourseId,
                    "courseTaskId":this.courseTaskId
                };
                GetCourseStudyUser(params).then(res=>{
                    if(res.code==200){
                        if(res.data.length==0){
                            this.userOptions=[];
                            return;
                        }
                        this.userOptions=res.data.map(item=>{
                            return {
                                label:item.user_name,
                                value:item.id
                            }
                        })
                        if(this.userOptions.length>0){
                            this.changeUser(this.userOptions[0].value);
                        }
                    }
                })
            },
            /**切换课程 */
            changeCourse(data){
                let el=this.options.find(e=>e.value==data);
                if(!el)return;
                this.courseInfo.id=el.courseId;
                this.detail.userId='';
                this.detail.userName='';
                this.getCourseStudyUser();
            },
            /**切换学生 */
            changeUser(data){
                let el=this.userOptions.find(e=>e.value==data);
                if(!el)return;
                this.detail.userId=el.value;
                this.detail.userName=el.label;
                let dialog=this.$refs.study_table;
                if(dialog){
                    dialog.pages.current=1;
                    dialog.pageQueryCourseStudyCount();
                }
            },
            /**关闭弹窗 */
            close(){
                let dialog=this.$refs.study_table;
                if(dialog){
                    dialog.listData=[];
                    dialog.detailList=[];
                }
                this.detail={
                    userId:'',
                    userName:''
                };
                this.courseInfo={
                    openCourseId:'',
                    id:''
                };
            }
        }
    }
</script>

<style lang="less" scoped>
/deep/.el-dialog__title{
    font-size: 16px;
    font-weight: 700;
    color: #334681;
}
/deep/.el-dialog{
    border-radius: 1rem;
}
.top-content-box{
    height: 6rem;
    background-color: #F3F7FC;
    display: flex;
    align-items: center;
    margin-top: 2rem;
    padding: 0 3.5rem;
    &> :nth-child(1){
        font-weight: 700;
        font-size: 16px;
    }
    &> :nth-child(2){
        margin-left: 1.5rem;
    }
    .hr{
        margin: 0 1.7rem;
        width: 1px;
        height: 2rem;
        background-color: #C2C7D9;
    }
}
.top-item{
    display: flex;
    &> :nth-child(2){
        margin-left: 1rem;
        color: var(--blue);
    }
}
.table-content-box{
    padding-top: 2.7rem;
    .box{
        margin-top: 3rem;
        height: 50rem;
    }
}
.table-title{
    font-weight: 700;
    margin-left: 3.5rem;
}
.select-label{
    display: flex;
    align-items: center;
}
/deep/.el-table--border th {
    background-color: #F3F7FC !important;
}
/deep/.el-table--border, .el-table--group{
    border: none !important;
}
/deep/.el-table--border::after, .el-table--group::after{
    width: 0 !important;
}
/deep/.el-table{
    border-radius: 0 !important;
}
</style>